import { Colors } from '@sigma-frontend-libs/commons'

import { components, services, sizes } from '@/utils'

import ruleConditions from '@/components/services/tariffs/rules/rule/conditions'
import packets from '@/components/services/tariffs/rules/rule/packets'
import priceRanges from '@/components/services/tariffs/rules/rule/priceRanges'
import rulePrices from '@/components/services/tariffs/rules/rule/prices'
import tag from '@/components/tag'

function renderTitle(h, index, isDefault) {
  let labelPath = 'rule'
  if (this.hasRules) {
    if (isDefault) {
      labelPath = 'otherCases'
    }
  } else {
    if (isDefault) {
      labelPath = 'always'
    }
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${services.tariffs}.${labelPath}`, { rule: index + 1 }),
        size: sizes.huge,
        color: Colors.grey
      }
    }
  )
}
function renderAction(h, { action }) {
  let actionColor
  if (action === 'decrease') {
    actionColor = Colors.error
  } else {
    actionColor = Colors.success
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${services.tariffs}.actions.${action}`),
        size: sizes.huge,
        color: actionColor
      }
    }
  )
}
function renderPrices(h, { price }) {
  return h(
    rulePrices,
    {
      props: {
        value: price,
        source: this.source,
        readonly: true
      }
    }
  )
}
function renderRuleHeader(h, rule, index, isDefault = false) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__header`
    },
    [
      renderTitle.call(this, h, index, isDefault),
      renderAction.call(this, h, rule),
      renderPrices.call(this, h, rule)
    ]
  )
}
function renderPriceRanges(h, rule) {
  return h(
    priceRanges,
    {
      props: {
        value: rule.priceRanges,
        readonly: true
      }
    }
  )
}
function renderPackets(h, rule) {
  return h(
    packets,
    {
      props: {
        value: rule.packets,
        readonly: true
      }
    }
  )
}
function renderRanges(h, rule) {
  const hasPriceRanges = Array.isArray(rule.priceRanges) && rule.priceRanges.length > 0
  const hasPackets = Array.isArray(rule.packets) && rule.packets.length > 0
  if (!hasPriceRanges && !hasPackets) {
    return
  }

  return h(
    'div',
    {
      class: `${services.tariffs}-rule__ranges`
    },
    [
      renderPriceRanges.call(this, h, rule),
      renderPackets.call(this, h, rule)
    ]
  )
}
function renderRuleConditions(h, conditions) {
  return h(
    ruleConditions,
    {
      props: {
        value: conditions,
        type: this.source,
        readonly: true
      }
    }
  )
}
function renderRuleBody(h, { rules }) {
  if (Array.isArray(rules) && rules.length) {
    return h(
      'div',
      {
        class: `${services.tariffs}-rule__body`
      },
      [
        rules.map(({ conditions }) => {
          return renderRuleConditions.call(this, h, conditions)
        })
      ]
    )
  }
}
function renderRule(h, rule, index, isDefault = false) {
  if (rule.action && rule.price) {
    return h(
      'div',
      {
        class: `${services.tariffs}-rule`
      },
      [
        renderRuleHeader.call(this, h, rule, index, isDefault),
        renderRanges.call(this, h, rule),
        renderRuleBody.call(this, h, rule)
      ]
    )
  }
}
function renderRules(h) {
  if (this.hasRules) {
    return this.rules.map((rule, index) => {
      return renderRule.call(this, h, rule, index)
    })
  }
}
function renderDefaultRule(h) {
  if (this.defaultRule) {
    return renderRule.call(this, h, this.defaultRule, 0, true)
  }
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rules__body`
    },
    [
      renderRules.call(this, h),
      renderDefaultRule.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components['expansion-panels'],
    {
      props: {
        rounded: true,
        outline: true
      }
    },
    [
      h(
        components['expansion-panel'],
        {
          scopedSlots: {
            header: () => {
              return h(
                'div',
                {
                  class: `${services.tariffs}-rules__panel`
                },
                [ this.getTranslate(`${services.tariffs}.titles.rules`) ]
              )
            },
            default: () => {
              return renderBody.call(this, h)
            }
          }
        }
      )
    ]
  )
}
